import { createFileRoute } from "@tanstack/react-router"

import { WallGraphic } from "@/components/wall/WallGraphic"
import { IntroContent } from "@/sections/layouts/IntroContent"

export const Route = createFileRoute("/$sessionId/_session/intro/permissions")({
  component: IntroPermissionsRoute,
})

function IntroPermissionsRoute() {
  const { sessionId } = Route.useParams()

  return (
    <IntroContent
      aboveHeading={<WallGraphic type="Permissions" />}
      activeStepIndex={2}
      numberOfSteps={5}
      linkProps={{ to: "/$sessionId/intro/wall", params: { sessionId } }}
      heading={{
        i18nKey: "intro.permissions.heading",
      }}
      description={{
        i18nKey: "intro.permissions.description",
        components: {
          uppercase: <span className="uppercase" />,
          bold: <span className="text-ic-primary font-bold" />,
        },
      }}
    />
  )
}
